export enum EventTypesEnum {
  TEMPERATURE_EXCURSION = 'TEMPERATURE_EXCURSION',
  LOW_BATTERY = 'LOW_BATTERY',
  LID_OPEN = 'LID_OPEN',
  DROP = 'DROP',
}

export enum EventStatusesEnum {
  NEW = 'NEW',
  REVIEWED = 'REVIEWED',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  ESCALATED = 'ESCALATED',
}

export type DispositionAction = 'accept' | 'reject' | 'escalate';

export interface EventDisposition {
  dispositionedBy: string;
  dispositionedByName: string;
  dispositionedAt: string;
  reason: string;
  signature: {
    signedBy: string;
    signedByName: string;
    signedAt: string;
    meaning: string;
  };
}

export interface EventEntity {
  _id: string;
  status: EventStatusesEnum;
  disposition?: EventDisposition;
  pid: string;
  deviceSerialNumber: string;
  eventType: EventTypesEnum;
  eventStart: string;
  detectionTimeSec?: number;
  eventEnd?: string;
  eventDetails: object;
  companyName: string;
  segment: string;
  shipmentPid: string;
}

export type StatusFilter = EventStatusesEnum | 'ALL';

export interface EventFilters {
  search?: string;
  startDate?: string;
  endDate?: string;
  status?: StatusFilter;
  companyIds?: string[];
  excludeCompanyIds?: string[];
}

export type TemperatureExcursionDetails = {
  deviationStage?: DeviationStage;
  maxDeviation?: number;
  deviationTempC?: number;
};

export enum DeviationStage {
  INITIAL_COOLDOWN = 'initialCooldown',
  STEADY_STATE = 'steadyState',
  CRITICAL = 'critical',
}
